import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../../models/base';

const LIST_ENDPOINT = '/adminusercomments';

@Injectable({
  providedIn: 'root',
})
export class AdminUserCommentsService {
  private readonly http = inject(HttpClient);

  async addData(userId: string, commentText: string): Promise<any> {
    const element = {
      commentText,
      commentForUsersId: userId,
    };

    const response = await firstValueFrom(
      this.http.post<ApiResponse<any>>(environment.apiUrl + LIST_ENDPOINT, element)
    );

    return response.data;
  }
}